import { ShowcaseContent } from '../types';

export const defaultShowcaseContent: ShowcaseContent = {
    showcaseTitle: "My Projects",
    showcaseSubtitle: "Here you'll find a showcase of my work as a full-stack mobile developer, specializing in the key pillars of modern digital experiences: cross-platform mobile development, robust backend architecture, user-centered UI/UX design, and compelling graphics. I thrive on the challenge of blending technical proficiency with creative vision to deliver impactful and user-friendly solutions. Take a look at my projects to see how these skills come together.",
    showcaseCategories: [
        { id: 'all', label: 'All' },
        { id: 'back-end', label: 'Back-end Development' },
        { id: 'design', label: 'Graphics Design' },
        { id: 'mobile-apps', label: 'Mobile Development' },
        { id: 'ui-ux', label: 'UI/UX Design' },
    ]
};
